import React from 'react'
import { Box,Typography } from '@mui/material'
import TabComponent from 'components/Tab'
const Team = () => {

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h4" fontSize="28px" fontWeight={800}>Team</Typography>
      <TabComponent/>
    </Box>
  )
}

export default Team